import React from 'react';

const Testimonials = () => {
    return (
        <section className="section" id="reviews">
            <div className="container">
                <h2 className="section__title">What Clients Say</h2>
                <p className="section__subtitle">
                    A few words from homeowners and businesses we’ve helped.
                </p>
                <div className="testimonials">
                    <div className="testimonial-card">
                        <p className="testimonial-card__text">
                            “Our home has never looked this clean. Reliable, friendly, and very thorough.”
                        </p>
                        <div className="testimonial-card__meta">Danielle • Guelph</div>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-card__text">
                            “Perfect for our small office. They work around our schedule and keep the place
                            spotless.”
                        </p>
                        <div className="testimonial-card__meta">Aron • Kitchener</div>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-card__text">
                            “Move-out cleaning was amazing. The landlord commented on how clean everything
                            was.”
                        </p>
                        <div className="testimonial-card__meta">Joseph • Waterloo</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
